import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9aa66a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"margin-bottom":"20px"} }, "Mis apuntes", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "search-form" }
const _hoisted_6 = { class: "aux-btns" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "container-items"
}

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import NoteService from '@/services/NoteService'
import { onMounted, ref, Ref } from 'vue'
import {useAuth} from '@/store/useAuth'
import NoteRow from '@/components/cards/NoteRow.vue'
import LessonService from '@/services/LessonService'
import CourseService from '@/services/CourseService'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyNotesView',
  setup(__props) {

const noteService = new NoteService()
const lessonService = new LessonService()
const courseService = new CourseService()
const loading = ref(true)
const store = useAuth()
const notes = ref([])
const fullNotes:Ref<any> = ref([])
const filteredNotes:Ref<any> = ref([])
const activeSearch = ref(0)
const search: Ref<string> = ref('')


onMounted(async () => {
    loading.value = true
    if (store.token) {
        notes.value = await noteService.GetAllNotesFromUser(store.token)
    }
    notes.value.forEach(async (note:any) => {
        const lesson = await lessonService.getLesson(note.lesson_id)
        const course = await courseService.GetCourse(lesson.course_id)
        fullNotes.value.push({
            'id': note.id,
            'content': note.note_content,
            'lesson': lesson.name,
            'course': course.name,
            'date': note.updated_at,
            'course_id': lesson.course_id,
            'lesson_id': note.lesson_id
        })
    });
    Promise.all(fullNotes.value)
    filteredNotes.value = fullNotes.value
    loading.value = false
})

const handleActiveSearch = (active:number) => {
    activeSearch.value = active
    search.value = ''
    filteredNotes.value = fullNotes.value
}

const handleSearchByContent = () => {
    loading.value = true
    filteredNotes.value = fullNotes.value.filter((item:any)=> item.content.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

const handleSearchByLesson = () => {
    loading.value = true
    filteredNotes.value = fullNotes.value.filter((item:any)=> item.lesson.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

const handleSearchByCourse = () => {
    loading.value = true
    filteredNotes.value = fullNotes.value.filter((item:any) => item.course.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_RouterLink, {
              to: {name: 'my-notes-pdf'},
              class: "print"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Imprimir apuntes en PDF")
              ]),
              _: 1
            }),
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              (activeSearch.value == 2)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                    placeholder: "Filtrar por contenido.",
                    onKeyup: handleSearchByContent
                  }, null, 544)), [
                    [_vModelText, search.value]
                  ])
                : _createCommentVNode("", true),
              (activeSearch.value == 0)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                    placeholder: "Filtrar por curso.",
                    onKeyup: handleSearchByCourse
                  }, null, 544)), [
                    [_vModelText, search.value]
                  ])
                : _createCommentVNode("", true),
              (activeSearch.value == 1)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 2,
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                    placeholder: "Filtrar por lección.",
                    onKeyup: handleSearchByLesson
                  }, null, 544)), [
                    [_vModelText, search.value]
                  ])
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleActiveSearch(0)), ["prevent"])),
                  class: "aux-btn"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "la-chalkboard-teacher-solid",
                    title: "Filtrar por curso",
                    fill: "#fff"
                  })
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleActiveSearch(1)), ["prevent"])),
                  class: "aux-btn"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "hi-solid-video-camera",
                    title: "Filtrar por lección",
                    fill: "#fff"
                  })
                ]),
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (handleActiveSearch(2)), ["prevent"])),
                  class: "aux-btn last"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "fa-table",
                    title: "Filtrar por nota (Contenido del apunte)",
                    fill: "#fff"
                  })
                ])
              ])
            ]),
            _hoisted_7,
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_v_icon, {
                    name: "ri-loader-2-fill",
                    animation: "spin",
                    class: "icon"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNotes.value, (note) => {
                    return (_openBlock(), _createBlock(NoteRow, {
                      key: note.id,
                      content: note
                    }, null, 8, ["content"]))
                  }), 128))
                ]))
          ]))
    ]),
    _: 1
  }))
}
}

})